<template>
  <div class="pageContent">
    <div class="pageTitleBox">
      <img src="../../assets/images/news2.png" alt="logo" class="pageTitleIcon">新闻资讯
    </div>
    <template v-if="loading">
      <div class="listItem" v-for="i in 1" :key="i" style="padding-top:20px">
        <a-skeleton active :avatar="{size: 'large', shape: 'square'}" :title="false" :paragraph="{rows: 4}" />
      </div>
    </template>
    
    <div class="listItem" v-for="(item, i) in list" :key="item.id">
      <div class="pageContentLogo">
        <div class="pageContentLogoTop">{{ item.addTime.split('-')[0] }}</div>
        <div class="pageContentLogoBottom">{{ item.addTime.split('-')[1] }}.{{ item.addTime.split('-')[2] }}</div>
      </div>
      <div class="pageContentWenzi">
        <div class="pageContentWenziTop">
          <div class="pageContentWenziLeft" @click="$router.push({ name: 'XinwenDetail', query: { noticeId: item.id, noticeName: item.headline } })">{{ item.headline }}</div>
          <div class="pageContentWenziRight" v-if="i == 0">头条Top</div>
          <img src="../../assets/images/huo.png" alt="heat" class="ttTop" v-if="i == 0">
          <img src="../../assets/images/huo.png" alt="heat" class="ttTop" v-if="i == 0">
          <img src="../../assets/images/huo.png" alt="heat" class="ttTop" v-if="i == 0">
          <!-- <div class="pageContentWenziRightA" v-if="i > 0" style="margin-left:10px">最热新闻</div>
          <div class="pageContentWenziRightB" v-if="i > 0">最热新闻</div> -->
        </div>
        <div class="pageContentWenziBottom">
          {{ item.contentText }}
        </div>
      </div>
    </div>
    
    <div class="paginationBox">
      <a-pagination size="small" :total="total" :pageSize="5" show-quick-jumper @change="tableChange" :show-total="total => `共${total}条记录`" />
    </div>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  name: 'xinwen',
  data() {
    return {
      list: [],
      loading: true,
      total: 0,
      pageNum: 1
    }
  },
  created() {
    this.onload()
  },
  methods: {
    onload() {
      let parameter = {
        pageNum: this.pageNum,
        pageSize: 5,
        type: 2
      }
      this.loading = true
      this.list = []
      http('/system/announcement/getList', 'POST', parameter).then(res => {
        this.loading = false
        if (res.success) {
          this.list = res.data.resultList
          this.total = res.data.total
        }
      })
    },
    tableChange(page) {
      this.pageNum = page
      this.onload()
    }
  }
}
</script>

<style lang="less" scoped>
.pageContent {
  width: 1220px;
  margin: 18px auto;
  padding: 0 32px;
}
.listItem {
  height: 140px;
  border-bottom: 1px solid #D9D9D9;
  // display: inline-block;
  position: relative
}
.pageContentLogo {
  width: 81px;
  height: 91px;
  position: absolute;
  margin-top: 24px;
  background-image: url('../../assets/images/bianzuB2.png');
}
.pageContentLogoTop {
  line-height: 30px;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  color: #fff;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
}
.pageContentLogoBottom {
  margin-top: 11px;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  color: #519bcd;
}
.pageContentWenzi {
  width: 100%;
  height: 80px;
  position: absolute;
  margin-left: 111px;
  margin-top: 24px;
}
.pageContentWenziTop {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 12px;
}
.pageContentWenziLeft {
  max-width: 800px;
  white-space: nowrap;        //不换行
  overflow: hidden;           //超出隐藏
  text-overflow: ellipsis;    //超出部分以冒号结尾
  height: 30px;
  font-size: 22px;
  color: #333;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.pageContentWenziRight {
  width: 64px;
  height: 28px;
  margin-left: 17px;
  border: 1px solid #F0933D;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  line-height: 28px;
  color: #F0933D;
}
.pageContentWenziRightA {
  width: 64px;
  height: 28px;
  margin-left: 17px;
  border: 1px solid #1D64A2;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  line-height: 28px;
  color: #1D64A2;
}
.pageContentWenziRightB {
  width: 64px;
  height: 28px;
  margin-left: 10px;
  border: 1px solid #519bcd;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  line-height: 28px;
  color: #519bcd;
}
.ttTop {
  width: 15px;
  height: 17px;
  margin-left: 10px;
}
.pageContentWenziBottom {
  width: 90%;
  height: 40px;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>